export enum ContractType {
  PACS_AURORA = 'PACS_AURORA',
  XCLINIC = 'XCLINIC',
  PADRAO = 'PADRAO',
  SMART = 'SMART',
  KORUS = 'KORUS'
}